module.exports = __webpack_public_path__ + "img/mi9.5846eca7.png";